import { common as enCommon } from './en/common';
import { common as koCommon } from './ko/common';
import { common as arCommon } from './ar/common';

const resources = {
  en: {
    common: enCommon,
  },
  ko: {
    common: koCommon,
  },
  ar: {
    common: arCommon,
  },
};

export default resources;
